import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import routes from "routes";

function findRouteName(pathname, routeList) {
  for (const route of routeList) {
    if (route.route) {
      const pattern = route.route.replace(/:[^/]+/g, "[^/]+");
      const regex = new RegExp(`^${pattern}$`);
      if (regex.test(pathname)) return route.name || route.key || "";
    }
    if (route.collapse) {
      const found = findRouteName(pathname, route.collapse);
      if (found) return found;
    }
  }
  return "";
}

export default function PageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const name = findRouteName(pathname, routes);
    document.title = name ? `${name} | LedgerHub` : "LedgerHub";
  }, [pathname]);

  return null;
}

